<template>
  <div>
    <QuotationHeader :img_header="header_image" header="ใบเสนอราคา" link_back="stock/quotation/quotationmain"/>
    <Quotation_detail/>
  </div>
</template>

<script>
import QuotationHeader from "@/components/admin/stock/quotation/header_quotation/QuotationHeader";
import HeaderImage from "@/assets/quotation.png";
import Quotation_detail from "@/components/admin/stock/quotation/Quotation_detail";
export default {
  name: "QuotationDetail",
  components: {
    Quotation_detail,
    QuotationHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
